<template>
  <div class="zj-demo-player">
    <zj-layout-container>
      <zj-layout-header>
        <h1 style="margin: 0rem 6rem;display:inline-block;">视频会议</h1>
        <label>房间号：</label>
        <el-input v-model="roomId" placeholder="房间号" style="margin: 0rem 1rem;width: auto;min-width:8rem;"></el-input>
        <label>密码：</label>
        <el-input v-model="pwd" placeholder="密码" style="margin: 0rem 1rem;width: auto;min-width:8rem;"></el-input>
        <label>姓名：</label>
        <el-input v-model="nick" placeholder="昵称" style="margin: 0rem 1rem;width: auto;min-width:8rem;"></el-input>
        <el-checkbox v-model="frontCam" style="font-size:1.6rem;">使用前置摄像机</el-checkbox>
        <div style="text-align: right;">
          <el-button type="primary" :disabled="joined" @click="handleJoinRoom" style="margin: 0rem 1rem;">加入</el-button>
          <el-button type="primary" :disabled="!joined" @click="handleLeaveRoom" style="margin: 0rem 1rem;">离开</el-button>
          <el-button type="primary" :disabled="!joined" @click="handleMute" style="margin: 0rem 1rem;">{{(mute?"取消静音":"静音")}}</el-button>
          <el-button type="primary" :disabled="!joined" @click="handleMuteAll" style="margin: 0rem 1rem;">{{(muteAll?"全体开麦":"全体禁麦")}}</el-button>
          <el-button type="primary" :disabled="!joined" @click="handleDeleteRoom" style="margin: 0rem 1rem;">解散房间</el-button>
        </div>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable" ref="container">
          <div class="zj-meeting-remote-peer">
            <video ref="localVideo" autoplay muted></video>
            <div class="zj-meeting-remote-peer-statusbar">
              <span class="nick">{{nick}}</span>
              <span class="audio">{{(mute ? '静音' : '')}}</span>
            </div>
          </div>
          <div ref="remoteVideos" style="margin-top: 2rem;"></div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import ZJApp from '../../../../app';
const ZJMeeting = ZJApp.ZJMeeting;
export default {
    name: 'ZjDemoMeeting',
    controller: 'UI',
    action: 'meeting',
    data () {
      return {
        roomId: 'room1',
        pwd: '123456',
        nick: '张三',
        joined: false,
        mute: false,
        muteAll: false,
        frontCam: true
      };
    },
    mounted() {
      const that = this;
      const signalServer = this.CNF('meetingCenter.signalServer');
      if (!signalServer) {
        this.$message.error('未配置信令服务器');
        return;
      }
      const remoteVideos = {
        appendPeerStream: function(video, peer) {
          let div = document.createElement('div');
          div.className = "zj-meeting-remote-peer";
          div.id = 'zj-meeting-remote-peer-' + peer.id;
          that.$refs.remoteVideos.appendChild(div);
          div.appendChild(video);
          let statusDiv = document.createElement('div');
          statusDiv.className = "zj-meeting-remote-peer-statusbar";
          div.appendChild(statusDiv);
          statusDiv.innerHTML = '<span class="nick">' + peer.nick + '</span>' +
            '&nbsp;&nbsp;<a href="javascript: void(0);" class="kick-link"><span>踢出</span></a>' +
            '&nbsp;&nbsp;<a href="javascript: void(0);" class="audio-link"><span class="audio unmute">静音</span></a>';
          let audioLink = statusDiv.querySelector('a.audio-link');
          let audioSpan = statusDiv.querySelector('span.audio');
          audioLink.onclick = function() {
            if (audioSpan.className.indexOf('unmute') != -1) {
              //静音
              that.mc.mute({
                target: peer.id // 目标 Peer 的 sessionId。all, 表示全体静音。
              });
            }
            else {
              //取消静音
              that.mc.unmute({
                target: peer.id
              });
            }
          };

          let kickLink = statusDiv.querySelector('a.kick-link');
          kickLink.onclick = function() {
            //踢出房间
            that.mc.kick({
              target: peer.id
            });
          };

        },
        removePeerStream: function(video, peer) {
          let id = 'zj-meeting-remote-peer-' + peer.id;
          let div = that.$refs.remoteVideos.querySelector('#' + id);
          that.$refs.remoteVideos.removeChild(div);
        },
        setMute: function(id, value) {
          let containerId = 'zj-meeting-remote-peer-' + id;
          let container = that.$refs.remoteVideos.querySelector('#' + containerId);
          let audioSpan = container.querySelector('span.audio');
          audioSpan.className = 'audio ' + (value ? 'mute' : 'unmute')
          audioSpan.innerHTML = value ? '取消静音' : '静音';
        }
      };
      //console.log('signalServer', signalServer);
      this.mc = new ZJMeeting.MeetingCenter({
        debug: false,
        signalServer: signalServer,
        autoConnect: false,
        
        localVideoEl: this.$refs.localVideo,
        remoteVideosEl: remoteVideos,
        autoRemoveVideos: true,
        autoRequestMedia: false,
        enableDataChannels: false,
        media: {
            audio: true,
            video: {
              facingMode: (this.frontCam ? "user" : "environment") // 前置摄像头/默认摄像机
            }
        }
      });

      this.mc.on('error', function(e) {
        that.$message.error(e.toString());
      });

      this.mc.on('readyToCall', function () {
        that.mc.joinRoom({
          name: that.roomId, // 房间名称
          pwd: that.pwd,     // 密码
          nick: that.nick,   // 昵称
          role: 0            // 在房间中的角色：0 - 普通成员, 1 - 房间创建人, 2 - 房间管理员
        });
      });

      this.mc.on('leftRoom', function() {
        setTimeout(function() {
          that.mc.disconnect();
        }, 0);
        that.mc.stopLocalVideo();
        that.mute = false;
        that.muteAll = false;
        that.joined = false;
      });
      
      //被踢出房间
      this.mc.on('kick', function() {
        that.$message({
          message: '您被踢出了房间',
          type: 'warning'
        });
      });
      
      //解散房间
      this.mc.on('deleteRoom', function() {
        that.$message({
          message: '房间已经被解散',
          type: 'warning'
        });
      });

      //本地开麦
      this.mc.on('audioOn', function() {
        that.mute = false;
      });

      //本地关麦
      this.mc.on('audioOff', function() {
        that.mute = true;
      });

      //远端关麦
      this.mc.on('mute', function(e) {
        remoteVideos.setMute(e.id, true);
      });

      //远端开麦
      this.mc.on('unmute', function(e) {
        remoteVideos.setMute(e.id, false);
      });
    },
    destroyed() {
      if(this.mc) {
        this.mc.destroy();
        this.mc = null;
      }
    },
    methods: {
      // 加入房间
      handleJoinRoom() {
        if (this.joined) {
          return;
        }

        this.joined = true;

        // 调用 startLocalVideo() 函数前，动态设置“前置摄像头/默认摄像机”配置
        this.mc.config.media.video.facingMode = this.frontCam ? "user" : "environment";

        this.mc.startLocalVideo();
        this.mc.connect();

      },
      handleLeaveRoom() {
        if (!this.joined) {
          return;
        }

        this.joined = false;

        this.mc.leaveRoom();

      },
      handleMute() {
        if (this.mute) {
          this.mute = false;
          this.mc.unmute();
        }
        else {
          this.mute = true;
          this.mc.mute();
        }
      },
      handleMuteAll() {
        if (this.muteAll) {
          this.muteAll = false;
          this.mc.unmute({
            target: 'all'
          });
        }
        else {
          this.muteAll = true;
          this.mc.mute({
            target: 'all'
          });
        }
      },
      handleDeleteRoom() {
        this.mc.deleteRoom();
      }

    }
}
</script>
